import React from "react"
import { WizardUnitStep1 } from "./WizardUnitStep1"
import { WizardUnitStep2 } from "./WizardUnitStep2"
import { WizardUnitStep3 } from "./WizardUnitStep3"
import { WizardUnitStep4 } from "./WizardUnitStep4"
import { WizardUnitStep5 } from "./WizardUnitStep5"
import { WizardUnitLoad } from "./WizardUnitLoad"

const WizardUnitPage = ({
                          roll, setRoll,
                          onFinish,
                          ipDetails,
                          property, setProperty,
                          propertySize, setPropertySize,
                          people, setPeople,
                          productsType, setProductsType,
                          innerStep,
                          setInnerStep,
                          onChangeCity,
                          city,
                          setEmail, setName, email, name,
                          isDemo
                        }) => {

  // const onBackPress = () => {
  //   setInnerStep(innerStep - 1)
  // }
  const _renderStep = () => {

    switch (innerStep) {
      case 0:
        return <WizardUnitStep1 roll={roll} setRoll={setRoll}
                                email={email} name={name} onChangeEmail={setEmail} onChangeName={setName} city={city}
                                onChangeCity={onChangeCity} ipDetails={ipDetails}
                                onClick={() => setInnerStep(1)} />
      case 1:
        return <WizardUnitStep2 property={property} setProperty={setProperty} onBackPress={() => setInnerStep(0)}
                                onClick={() => {
                                  setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 2 : 3)
                                }} />
      case 2:
        return <WizardUnitStep3 propertyKey={property?.key} propertySize={propertySize}
                                onBackPress={() => setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 1 : 3)}
                                onClick={(newPropertySize) => {
                                  setPropertySize(newPropertySize)
                                  setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 3 : 4)
                                }} />
      case 3:
        return <WizardUnitStep4 propertyKey={property?.key} people={people}
                                onBackPress={() => setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 2 : 1)}
                                onClick={(newPeople) => {
                                  setPeople(newPeople)
                                  setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 4 : 2)
                                }} />
      case 4:
        return <WizardUnitStep5 productsType={productsType}
                                onBackPress={() => setInnerStep(["residential", "studentHousing"].includes(property?.key) ? 3 : 2)}
                                onClick={(newProductsType) => {
                                  setProductsType(newProductsType)
                                  setInnerStep(5)
                                }} />
      case 5:
        return <WizardUnitLoad isDemo={isDemo} onClick={() => {
          onFinish()
        }} />
      default:
        break;
    }
  }

  return <div>

    {_renderStep()}
  </div>

}

export { WizardUnitPage }
